import React from "react";
import { useNavigate } from "react-router-dom";

type PropsType = {
  petName?: string;
  gender?: string;
  breed?: string;
  _id?: string;
};

const PetsMobileTable = ({ petName, gender, breed, _id }: PropsType) => {
  const navigate = useNavigate();
  return (
    <div className="tw-w-[85%] tw-mx-auto tw-bg-white tw-py-6 tw-shadow-small tw-rounded-[1rem]">
      <div className="tw-w-[90%] tw-mx-auto tw-flex tw-flex-col tw-gap-3">
        {/* 1st main col */}
        <div className="tw-flex tw-flex-col tw-gap-2">
          {/* 1st col */}
          <div className="tw-flex tw-items-center tw-justify-between">
            <span className="tw-font-bold tw-text-base tw-text-darkPurple ">
              My Pets
            </span>
            <span className="">{petName && petName ? petName : "None"}</span>
          </div>

          {/* 2nd col */}
          <div className="tw-flex tw-items-center tw-justify-between">
            <span className=" tw-font-bold tw-text-base tw-text-darkPurple ">
              Gender
            </span>
            <span className="tw-text-left">{gender ? gender : "None"}</span>
          </div>

          {/* 3rd col */}
          <div className="tw-flex tw-items-center tw-justify-between">
            <span className="tw-font-bold tw-text-base tw-text-darkPurple">
              Pet Breed
            </span>
            <span className="tw-text-right tw-capitalize">{breed ? breed : "None"}</span>
          </div>
        </div>
        {/* 2nd main col */}
        <div className="tw-w-[80%] tw-mx-auto tw-flex tw-items-center tw-justify-center">
          <button
            className="tw-bg-[#FF7B6D] tw-py-1.5 tw-px-8 tw-rounded-[0.625rem] tw-text-[0.75rem] tw-text-[#FFFFFF]"
            onClick={() => {
              navigate(`/user/pets/pet-details/${_id}`);
            }}
          >
            Pet Details
          </button>
        </div>
      </div>
    </div>
  );
};

export default PetsMobileTable;
